// FONT SIZE HEIRARCHY
const FONT_SIZE_24 = 24;
const FONT_SIZE_14 = 14;
const FONT_SIZE_12 = 12;
const FONT_SIZE_10 = 10;
const FONT_SIZE_9 = 9;

// FONT COLOR 
const PRIMARY_TEXT = '#182146';
const CATSKILL_WHITE = '#F1F4F8';
const TERTIARY_ACCENT = '#4B73A7';
const SUCCESS = '#52B987';
const DANGER = '#FF5555';
const ATHENS_GRAY = '#edeef0';
const SECONDARY_TEXT = '#969aab';

export {
  FONT_SIZE_24,
  FONT_SIZE_14,
  FONT_SIZE_12,
  FONT_SIZE_10,
  FONT_SIZE_9,
  PRIMARY_TEXT,
  CATSKILL_WHITE,
  TERTIARY_ACCENT,
  SUCCESS,
  DANGER,
  ATHENS_GRAY,
  SECONDARY_TEXT,
};
